<template>
  <v-btn @click="checkValidation(download)" color="success" :loading="loading">Скачать Excel</v-btn>
</template>

<script>
import {downloadBlobFile} from "@/utils/pureFunctions";

export default {
  name: 'DownloadExcelReportList',
  props: {
    filter: {
      default() {
        return {}
      }
    },
    checkValidation: {
      type: Function,
      default() {
        return (cb) => {
          cb()
        }
      }
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async download() {
      this.loading = true
      try {
        const {data} = await this.$http.get('admin/calculate/report', {
          params: {...this.filter, excel: 1},
          responseType: 'blob'
        })
        downloadBlobFile(data, 'report.xlsx')
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.loading = false
      }
    }
  }
}
</script>